import { Component, Input } from "@angular/core";

import { StringHelper } from "@tylertech/shared-module";
import { CustomViewService } from "@tylertech/custom-view";
import { IAggregate } from "@tylertech/tyler-api-types";

import { AggregateBindingObject } from "../interfaces";
import { AggregateHelperService } from "../services";

@Component({
    selector: "aggregate-chart",
    templateUrl: "./aggregateChart.tmpl.html",
    standalone: false
})
export class AggregateChartComponent
{
    private _aggregate: IAggregate;

    isCustomView: boolean;
    customComponent: string | undefined;
    customData: AggregateBindingObject | undefined;

    constructor(
        private readonly customViewService: CustomViewService,

        private readonly $aggregateHelperService: AggregateHelperService)
    { }

    @Input()
    get aggregate(): IAggregate { return this._aggregate; }

    set aggregate(value: IAggregate)
    {

        this._aggregate = value;

        const selector = this._aggregate?.AggregateProviderId
            ? StringHelper.toKebabCase(this._aggregate.AggregateProviderId.replace(".", ""))
            : undefined;

        this.isCustomView = this.customViewService.hasView(selector);

        this.customComponent = selector;
        this.customData = {
            aggregate: this._aggregate,
        };
    }

    get isHidden(): boolean
    {
        return this.$aggregateHelperService.isHidden(this.aggregate);
    }
}
